import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { UserContext } from '../../UserContext';
import { useHttpClient } from '../hooks/useHttpClient';
import { useNotificacoes } from '../hooks/useNotificacoes';

import InputMask from 'react-input-mask';
import styles from './DetalharEmpresa.module.css';
import styles_global from '../css/global.module.css';
import styles_content from '../css/main-content.module.css';

function DetalharEmpresa() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { get } = useHttpClient();
  const { exibirErro } = useNotificacoes();

  const [formData, setFormData] = useState({
    nome: '', cnpj: '', telefone: '', email: '',
    cep: '', endereco: '', complementoEndereco: '',
    bairro: '', municipio: '', uf: '',
    logoEmpresa: '', site: '', missao: ''
  });

  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else if (id) {
      carregarEmpresa();
    }
  }, [user, id, navigate]);

  const carregarEmpresa = async () => {
    try {
      const data = await get(`/hello-sol/empresas/${id}`);
      setFormData(data);
    } catch (err) {
      exibirErro(err.message || 'Erro ao carregar empresa.');
    }
  };

  return (
      <div className={styles_global.container}>
        <h2>Detalhar Empresa</h2>
        <form>
          {/* Linha 1: CNPJ / Nome */}
          <div className={styles.linha2}>
            <div className={styles_content.formField}>
              <label>CNPJ</label>
              <InputMask mask="99.999.999/9999-99" value={formData.cnpj} disabled>
                {props => <input {...props} />}
              </InputMask>
            </div>
            <div className={styles_content.formField}>
              <label>Nome</label>
              <input className={styles.campoNomeEmpresa} type="text" value={formData.nome} disabled />
            </div>
          </div>

          {/* Linha 2: Telefone / Email */}
          <div className={styles.linha2}>
            <div className={styles_content.formField}>
              <label>Telefone</label>
              <InputMask mask="(99) 99999-9999" value={formData.telefone} disabled>
                {props => <input {...props} />}
              </InputMask>
            </div>
            <div className={styles_content.formField}>
              <label>Email</label>
              <input className={styles.campoEmailEmpresa} type="email" value={formData.email} disabled />
            </div>
          </div>

          {/* Linha Missao */}
          <div className={styles.linhaSiteMissao}>
            <div className={styles_content.formField}>
              <label htmlFor="site">Site da Empresa</label>
              <input
                  id="site"
                  name="site"
                  value={formData.site}
                  placeholder="Digite o Site da Empresa"
                  className={styles.campoSite}
                  maxLength={50}
                  disabled
              />
            </div>
            <div className={styles_content.formField}>
              <label htmlFor="missao">Missão da Empresa</label>
              <textarea
                  id="missao"
                  name="missao"
                  value={formData.missao}
                  placeholder="Descreva a missão da empresa, essa informação aparecerá na fatura."
                  maxLength={300}
                  className={styles.textArea}
                  disabled
              />
            </div>
          </div>

          {/* Linha 3: CEP / Endereço / Complemento */}
          <div className={styles.linha3}>
            <div className={styles_content.formField}>
              <label>CEP</label>
              <InputMask  className={styles.campoCepEmpresa} mask="99999-999" value={formData.cep} disabled>
                {props => <input {...props} />}
              </InputMask>
            </div>
            <div className={styles_content.formField}>
              <label>Endereço</label>
              <input className={styles.campoEnderecoEmpresa} type="text" value={formData.endereco} disabled />
            </div>
            <div className={styles_content.formField}>
              <label>Complemento</label>
              <input type="text" value={formData.complementoEndereco} disabled />
            </div>
          </div>

          {/* Linha 4: Bairro / Município / UF */}
          <div className={styles.linha3}>
            <div className={styles_content.formField}>
              <label>Bairro</label>
              <input type="text" value={formData.bairro} disabled />
            </div>
            <div className={styles_content.formField}>
              <label>Município</label>
              <input className={styles.campoMunicipioEmpresa} type="text" value={formData.municipio} disabled />
            </div>
            <div className={styles_content.formField}>
              <label>UF</label>
              <input type="text" value={formData.uf} maxLength={2} disabled />
            </div>
          </div>

          {/* Linha 5: Logo da Empresa */}
          <div className={styles.linhaLogo}>
            <div className={styles.logoField}>
              <label><strong>Logo da Empresa</strong></label>
              {formData.logoEmpresa && (
                  <img
                      src={formData.logoEmpresa}
                      alt="Logo da Empresa"
                      className={styles.logoPreview}
                  />
              )}
            </div>
          </div>

          {/* Botão Voltar */}
          <div className={styles_content.buttonGroup}>
            <button type="button" onClick={() => navigate('/home/listar-empresa')}>
              Voltar
            </button>
          </div>
        </form>
      </div>
  );
}

export default DetalharEmpresa;
